import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function DecksIcon(props: IIcon) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <g>
                <path d="M469.2,180.6h-98.8c-5.8,0-10.4,4.7-10.4,10.4v49.4h-68.4c-5.8,0-10.4,4.7-10.4,10.4v47.6h-73.8c-5.8,0-10.4,4.7-10.4,10.4v53h-68.4c-5.8,0-10.4,4.7-10.4,10.4v53.9H40.6c-5.8,0-10.4,4.7-10.4,10.4v27.2c0,5.8,4.7,10.4,10.4,10.4S51,469.5,51,463.7V447h77.5c5.8,0,10.4-4.7,10.4-10.4v-53.9h68.4c5.8,0,10.4-4.7,10.4-10.4v-53h73.8c5.8,0,10.4-4.7,10.4-10.4v-47.6h68.4c5.8,0,10.4-4.7,10.4-10.4v-49.4h77.9v284.5H75c-5.8,0-10.4,4.7-10.4,10.4c0,5.8,4.7,10.4,10.4,10.4h394.1c5.8,0,10.4-4.7,10.4-10.4V191C479.6,185.3,474.9,180.6,469.2,180.6z" />
                <path d="M43.2,284.6l13.3-9.9v127.4c0,5.8,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4V259.2l59.8-44.4v123.9c0,5.8,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4V199.3l59.8-44.4v120.4c0,5.8,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4V142.1c0-0.9-0.1-1.7-0.3-2.5L298.4,95v116.9c0,5.8,4.7,10.4,10.4,10.4c5.8,0,10.4-4.7,10.4-10.4V79.5L379,35.1v113.4c0,5.8,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4V24.8h66.6c5.8,0,10.4-4.7,10.4-10.4S472.2,4,466.4,4h-77c-2.2,0-4.4,0.7-6.2,2.1L30.8,267.8c-4.6,3.4-5.6,10-2.1,14.6c2,2.8,5.2,4.2,8.4,4.2C39.2,286.6,41.3,286,43.2,284.6z" />
                <circle cx="41.1" cy="496.4" r="10.5" />
            </g>
        </Icon>
    );
}
